import { render, staticRenderFns } from "./CourseItems.vue?vue&type=template&id=0d5b829d&"
import script from "./CourseItems.vue?vue&type=script&lang=js&"
export * from "./CourseItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../buildchain/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports